import React, { FC } from 'react';
import { Toaster } from 'react-hot-toast';

// ルートに一つのみ存在するべきコンポーネント
export const RSToastContainer: FC = () => {
  return (
    <Toaster
      position="bottom-right"
      gutter={0}
      containerClassName="m-1 pc:m-2"
      toastOptions={{
        duration: 8000,
      }}
    />
  );
};
